import { GraduationCap, Landmark, BriefcaseBusiness, FileCheck2 } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: GraduationCap,
    title: "International Student Admissions",
    desc: "End-to-end admission support for the USA, UK, Germany and Latvia — profile mapping, university shortlisting, SOP/LOR guidance and application management.",
    span: "lg:col-span-4",
  },
  {
    icon: Landmark,
    title: "Institutional Governance & Advisory",
    desc: "Strategic counsel for universities establishing on-site campuses in India.",
    span: "lg:col-span-2",
  },
  {
    icon: BriefcaseBusiness,
    title: "Apprentice Placement & Internships",
    desc: "Structured apprentice placement with industry partners in India and abroad.",
    span: "lg:col-span-2",
  },
  {
    icon: FileCheck2,
    title: "Visa & Financial Counselling",
    desc: "Documentation, financial planning, scholarship strategy and mock visa interviews handled by seasoned counsellors — so every file stands up to scrutiny.",
    span: "lg:col-span-4",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-20 lg:py-28 bg-[#F8FAFC] border-t border-slate-900/10">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.18em] text-amber-800">02 — What We Do</p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B192C] mt-3 leading-[1.05]">
          The four pillars of <em className="italic text-amber-600">Orion Edcon</em>
        </h2>
      </Reveal>
      <div className="grid lg:grid-cols-6 gap-6 mt-14">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className={s.span}>
            <article data-testid={`service-card-${i}`}
              className="group h-full bg-white border border-slate-900/10 rounded-2xl p-8 hover:border-amber-500/60 hover:shadow-xl hover:shadow-amber-900/5 hover:-translate-y-1 transition-all duration-300 flex flex-col">
              <span className="w-12 h-12 rounded-xl bg-[#0B192C] flex items-center justify-center group-hover:bg-amber-600 transition-colors duration-300">
                <s.icon className="w-6 h-6 text-white" />
              </span>
              <h3 className="font-heading text-xl sm:text-2xl font-semibold text-[#0B192C] mt-5">{s.title}</h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed mt-3 flex-1">{s.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
